import React, { ComponentProps } from 'react';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { RoleSettingsDefaultForm } from './views/RoleSettingsDefaultForm';

type RoleDefaultForPageTypeSettingsProps = Views<DefaultView<RoleSettingsDefaultForm>>;
function RoleDefaultForPageTypeSettings(props: RoleDefaultForPageTypeSettingsProps) {
  return <RoleSettingsDefaultForm {...props.views.default} />;
}

export const RoleDefaultForPageTypeSettingsBlock = asBlock(
  RoleDefaultForPageTypeSettings,
  BlockType.roledefaultforpagetypesettings,
);
export type RoleDefaultForPageTypeSettingsBlock = ComponentProps<typeof RoleDefaultForPageTypeSettingsBlock>;
